import { lazy } from "react";

// project import
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Dashboard";
import PagesLayout from "layout/Pages";
import SimpleLayout from "layout/Simple";
import { SimpleLayoutType } from "config";
        

//-------------------------------------
// Template pages routing
const AuthLogin = Loadable(lazy(() => import("pages/auth/login")));
const AuthRegister = Loadable(lazy(() => import("pages/auth/register")));
const AuthForgotPassword = Loadable(lazy(() => import("pages/auth/forgot-password")));
const AuthResetPassword = Loadable(lazy(() => import("pages/auth/reset-password")));
const AuthResetPasswordResponse = Loadable(lazy(() => import("pages/auth/reset-password-confirmation")));
const AuthCheckMail = Loadable(lazy(() => import("pages/auth/check-mail")));
const AuthCodeVerification = Loadable(lazy(() => import("pages/auth/code-verification")));

const MaintenanceError = Loadable(lazy(() => import("pages/maintenance/404")));
const MaintenanceError500 = Loadable(lazy(() => import("pages/maintenance/500")));
const MaintenanceUnderConstruction = Loadable(lazy(() => import("pages/maintenance/under-construction")));
const MaintenanceComingSoon = Loadable(lazy(() => import("pages/maintenance/coming-soon")));

//-------------------------------------
// pages routing

const DashboardRouter = Loadable(lazy(() => import("pages/content/dashboards/router")));
const DashboardPrincipal = Loadable(lazy(() => import("pages/content/dashboards/principal")));
const DashboardTecnicos = Loadable(lazy(() => import("pages/content/dashboards/tecnicos")));

// WhatsApp module
const WhatsappPage = Loadable(lazy(() => import("pages/content/whatsapp")));


// Templates
const Esignature = Loadable(lazy(() => import("pages/content/templates/esignature")));
const PruebasDiagrama = Loadable(lazy(() => import("pages/content/templates/pruebas-diagrama")));

// Agenda Servicios
const AgendaDiaria = Loadable(lazy(() => import("pages/content/agenda-servicios/agenda-diaria")));
const CalendarioMensual = Loadable(lazy(() => import("pages/content/agenda-servicios/calendario-mensual")));

// Agenda Diaria Tecnico
const AgendaDiariaTecnico = Loadable(lazy(() => import("pages/content/agenda-diaria-tecnico")));

// Almacén
const CatalogoInsumos = Loadable(lazy(() => import("pages/content/almacen/catalogo-insumos")));
const Existencias = Loadable(lazy(() => import("pages/content/almacen/existencias")));
const BitacoraMovimientos = Loadable(lazy(() => import("pages/content/almacen/bitacora-movimientos")));
const TransferenciaTecnicos = Loadable(lazy(() => import("pages/content/almacen/transferencia-tecnico")));

// Caja Chica
const SaldoMovimientos = Loadable(lazy(() => import("pages/content/caja-chica/saldo-movimientos")));
const AgregarGasto = Loadable(lazy(() => import("pages/content/caja-chica/agregar-gasto")));
const BitacoraCobros = Loadable(lazy(() => import("pages/content/caja-chica/bitacora-cobros")));

// Catálogos
const UsuariosSistema = Loadable(lazy(() => import("pages/content/catalogos/usuarios-sistema")));
const Clientes = Loadable(lazy(() => import("pages/content/cotizaciones/clientes")));
const Tecnicos = Loadable(lazy(() => import("pages/content/catalogos/tecnicos")));
const Plagas = Loadable(lazy(() => import("pages/content/catalogos/plagas")));
const Constantes = Loadable(lazy(() => import("pages/content/catalogos/constantes")));
const Unidades = Loadable(lazy(() => import("pages/content/catalogos/unidades")));
const TiposServicios = Loadable(lazy(() => import("pages/content/catalogos/tipos-servicios")));
const Dosificaciones = Loadable(lazy(() => import("pages/content/catalogos/dosificaciones")));
const GastosCajaChica = Loadable(lazy(() => import("pages/content/catalogos/gastos-caja-chica")));
const Plantillas = Loadable(lazy(() => import("pages/content/catalogos/plantillas")));

// Comisiones
const PendientesPago = Loadable(lazy(() => import("pages/content/comisiones/pendientes-pago")));
const Pagadas = Loadable(lazy(() => import("pages/content/comisiones/pagadas")));

// Cotizaciones
const NuevaCotizacion = Loadable(lazy(() => import("pages/content/cotizaciones/nueva-cotizacion")));
const Cotizaciones = Loadable(lazy(() => import("pages/content/cotizaciones/cotizaciones")));
const HistoricoCotizaciones = Loadable(lazy(() => import("pages/content/cotizaciones/historico-cotizaciones")));

// Finanzas
const ComisionesPorPagar = Loadable(lazy(() => import("pages/content/finanzas/por-pagar-desglosado")));
const ComisionesPorPagar2 = Loadable(lazy(() => import("pages/content/finanzas/comisiones-por-pagar")));
const HistoricoComisiones = Loadable(lazy(() => import("pages/content/finanzas/historico-comisiones")));
const BitacoraPagosComisiones = Loadable(lazy(() => import("pages/content/finanzas/bitacora-pagos-comisiones")));
const BitacoraCortes = Loadable(lazy(() => import("pages/content/finanzas/caja-chica/bitacora-cortes")));
const CXC = Loadable(lazy(() => import("pages/content/finanzas/cuentas-por-cobrar/cxc")));
const CobrosConciliados = Loadable(lazy(() => import("pages/content/finanzas/cuentas-por-cobrar/cobros-conciliados")));
const CobrosNoConciliados = Loadable(lazy(() => import("pages/content/finanzas/cuentas-por-cobrar/cobros-no-conciliados")));
const CorteDiario = Loadable(lazy(() => import("pages/content/finanzas/corte-diario")));
const CajaChicaTecnicos = Loadable(lazy(() => import("pages/content/finanzas/bitacora-movimientos")));
const CortesPorTecnico = Loadable(lazy(() => import("pages/content/finanzas/caja-chica/cortes-por-tecnico")));
const CajaSaldo = Loadable(lazy(() => import("pages/content/finanzas/caja-saldo")));
const CajaBitacoraMovimientos = Loadable(lazy(() => import("pages/content/finanzas/caja-bitacora-movimientos")));

// Insumos
const ExistenciasInsumos = Loadable(lazy(() => import("pages/content/insumos/existencias")));
const BitacoraMovimientosInsumos = Loadable(lazy(() => import("pages/content/insumos/bitacora-movimientos")));

// Órdenes de Servicio
const OrdenesPendientes = Loadable(lazy(() => import("pages/content/ordenes-servicio/ordenes-pendientes")));
const OrdenesCompletadas = Loadable(lazy(() => import("pages/content/ordenes-servicio/ordenes-completadas")));
const ServiciosRefuerzo = Loadable(lazy(() => import("pages/content/ordenes-servicio/servicios-refuerzo")));
const HistorialServiciosRefuerzo = Loadable(lazy(() => import("pages/content/ordenes-servicio/historial-servicios-refuerzo")));
const CrearReporteServicio = Loadable(lazy(() => import("pages/content/ordenes-servicio/reporte-servicio-form")));
const ReportesServicios = Loadable(lazy(() => import("pages/content/ordenes-servicio/reportes-servicios")));
const AgregarCobro = Loadable(lazy(() => import("pages/content/finanzas/cuentas-por-cobrar/agregar-cobro")));

// Cuenta
const DatosContacto = Loadable(lazy(() => import("pages/content/cuenta/datos-contacto")));
const EstadoCuenta = Loadable(lazy(() => import("pages/content/cuenta/estado-cuenta")));
const Soporte = Loadable(lazy(() => import("pages/content/cuenta/soporte")));

// Tasks Kanban Board
const TasksKanbanBoard = Loadable(lazy(() => import("pages/content/tasks-kanban-board")));

// Funnel de Ventas
const FunnelVentasPage = Loadable(lazy(() => import("pages/content/funnel-ventas")));
const KanbanTarjetas = Loadable(lazy(() => import("pages/content/funnel-ventas/kanban-tarjetas")));

// Kanban Board
const KanbanBoardPage = Loadable(lazy(() => import("pages/content/kanban-board")));

// Kanban Board 2
const KanbanBoard2Page = Loadable(lazy(() => import("pages/content/kanban-board-2")));

const LogoutPage = Loadable(lazy(() => import("pages/auth/logout")));




// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          path: "home",
          children: [
            {
              path: "",
              element: <DashboardRouter />,
            },
          ],
        },
        {
          path: "dashboard",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <DashboardPrincipal />,
            },
            {
              path: "principal",
              element: <DashboardPrincipal />,
            },
            {
              path: "tecnicos",
              element: <DashboardTecnicos />,
            },
          ],
        },
        {
          path: "tasks-board",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <TasksKanbanBoard />,
            },
          ],
        },
        {
          path: "kanban-board",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <KanbanBoardPage />,
            },
          ],
        },
        {
          path: "kanban-board-2",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <KanbanBoard2Page />,
            },
          ],
        },
        {
          path: "whatsapp",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <WhatsappPage />,
            },
          ],
        },
        {
          path: "templates",
          element: <PagesLayout />,
          children: [
            {
              path: "esignature",
              element: <Esignature />,
            },
            {
              path: "pruebas-diagrama",
              element: <PruebasDiagrama />,
            },
          ],
        },
        {
          path: "agenda-servicios",
          element: <PagesLayout />,
          children: [
            {
              path: "agenda-diaria",
              element: <AgendaDiaria />,
            },
            {
              path: "calendario-mensual",
              element: <CalendarioMensual />,
            },
          ],
        },
        {
          path: "agenda-diaria-tecnico",
          element: <PagesLayout />,
          children: [
            {
              path: "",
              element: <AgendaDiariaTecnico />,
            },
          ],
        },
        {
          path: "almacen",
          element: <PagesLayout />,
          children: [
            {
              path: "catalogo-insumos",
              element: <CatalogoInsumos />,
            },
            {
              path: "existencias",
              element: <Existencias />,
            },
            {
              path: "bitacora-movimientos",
              element: <BitacoraMovimientos />,
            },
            {
              path: "transferencia-tecnicos",
              element: <TransferenciaTecnicos />,
            },
          ],
        },
        {
          path: "caja-chica",
          element: <PagesLayout />,
          children: [
            {
              path: "saldo-movimientos",
              element: <SaldoMovimientos />,
            },
            {
              path: "agregar-gasto",
              element: <AgregarGasto />,
            },
            {
              path: "bitacora-cobros",
              element: <BitacoraCobros />,
            },
          ],
        },
        {
          path: "catalogos",
          element: <PagesLayout />,
          children: [
            {
              path: "usuarios-sistema",
              element: <UsuariosSistema />,
            },
            {
              path: "tecnicos",
              element: <Tecnicos />,
            },
            {
              path: "plagas",
              element: <Plagas />,
            },
            {
              path: "constantes",
              element: <Constantes />,
            },
            {
              path: "unidades",
              element: <Unidades />,
            },
            {
              path: "tipos-servicios",
              element: <TiposServicios />,
            },
            {
              path: "dosificaciones",
              element: <Dosificaciones />,
            },
            {
              path: "gastos-caja-chica",
              element: <GastosCajaChica />,
            },
            {
              path: "plantillas",
              element: <Plantillas />,
            },
          ],
        },
        {
          path: "comisiones",
          element: <PagesLayout />,
          children: [
            {
              path: "pendientes-pago",
              element: <PendientesPago />,
            },
            {
              path: "pagadas",
              element: <Pagadas />,
            },
          ],
        },
        {
          path: "cotizaciones",
          element: <PagesLayout />,
          children: [
            {
              path: "nueva-cotizacion",
              element: <NuevaCotizacion />,
            },
            {
              path: "cotizaciones",
              element: <Cotizaciones />,
            },
            {
              path: "clientes",
              element: <Clientes />,
            },
            {
              path: "historico-cotizaciones",
              element: <HistoricoCotizaciones />,
            },
            {
              path: "funnel-de-ventas",
              element: <FunnelVentasPage />,
            },
            {
              path: "funnel-de-ventas/kanban-tarjetas",
              element: <KanbanTarjetas />,
            },
          ],
        },
        {
          path: "finanzas",
          element: <PagesLayout />,
          children: [
            {
              path: "corte-diario",
              element: <CorteDiario />,
            },
            {
              path: "caja-chica",
              children: [
                {
                  path: "cortes-por-tecnico",
                  element: <CortesPorTecnico />,
                },
                {
                  path: "bitacora-cortes",
                  element: <BitacoraCortes />,
                },
              ],
            },
            {
              path: "cuentas-por-cobrar",
              children: [
                {
                  path: "cxc",
                  element: <CXC />,
                },
                {
                  path: "cobros-conciliados",
                  element: <CobrosConciliados />,
                },
                {
                  path: "cobros-no-conciliados",
                  element: <CobrosNoConciliados />,
                },
                {
                  path: "agregar-cobro",
                  element: <AgregarCobro />,
                },
              ],
            },

            {
              path: "bitacora-movimientos-caja-chica",
              element: <CajaChicaTecnicos />,
            },
            {
              path: "comisiones-por-pagar",
              element: <ComisionesPorPagar2 />,
            },
            {
              path: "por-pagar-desglosado",
              element: <ComisionesPorPagar />,
            },
            {
              path: "historico-comisiones",
              element: <HistoricoComisiones />,
            },
            {
              path: "bitacora-pagos-comisiones",
              element: <BitacoraPagosComisiones />,
            },
            {
              path: "caja-saldo",
              element: <CajaSaldo />,
            },
            {
              path: "caja-bitacora-movimientos",
              element: <CajaBitacoraMovimientos />,
            },
          ],
        },
        {
          path: "insumos",
          element: <PagesLayout />,
          children: [
            {
              path: "existencias",
              element: <ExistenciasInsumos />,
            },
            {
              path: "bitacora-movimientos",
              element: <BitacoraMovimientosInsumos />,
            },
          ],
        },
        {
          path: "ordenes-servicio",
          element: <PagesLayout />,
          children: [
            {
              path: "ordenes-pendientes",
              element: <OrdenesPendientes />,
            },
            {
              path: "ordenes-completadas",
              element: <OrdenesCompletadas />,
            },
            {
              path: "servicios-refuerzo",
              element: <ServiciosRefuerzo />,
            },
            {
              path: "historial-servicios-refuerzo",
              element: <HistorialServiciosRefuerzo />,
            },
            {
              path: "reporte-servicio-form",
              element: <CrearReporteServicio />,
            },
            {
              path: "reportes-servicios",
              element: <ReportesServicios />,
            },
          ],
        },
        {
          path: "cuenta",
          element: <PagesLayout />,
          children: [
            {
              path: "datos-contacto",
              element: <DatosContacto />,
            },
            {
              path: "estado-cuenta",
              element: <EstadoCuenta />,
            },
            {
              path: "soporte",
              element: <Soporte />,
            },
          ],
        },
        {
          path: "logout",
          element: <LogoutPage />,
        },
        
      ],
    },

    {
      path: "/maintenance",
      element: <PagesLayout />,
      children: [
        {
          path: "404",
          element: <MaintenanceError />,
        },
        {
          path: "500",
          element: <MaintenanceError500 />,
        },
        {
          path: "under-construction",
          element: <MaintenanceUnderConstruction />,
        },
        {
          path: "coming-soon",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "/auth",
      element: <PagesLayout />,
      children: [
        {
          path: "login",
          element: <AuthLogin />,
        },
        {
          path: "register",
          element: <AuthRegister />,
        },
        {
          path: "forgot-password",
          element: <AuthForgotPassword />,
        },
        {
          path: "reset-password",
          element: <AuthResetPassword />,
        },
        {
          path: "reset-password-confirmation",
          element: <AuthResetPasswordResponse />,
        },
        {
          path: "check-mail",
          element: <AuthCheckMail />,
        },
        {
          path: "code-verification",
          element: <AuthCodeVerification />,
        },
      ],
    },
    {
      path: "/",
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: "contact-us",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
    {
      path: "*",
      element: <MaintenanceError />,
    },
  ],
};

export default MainRoutes;
